import ProUserPage from './ProUserPage';

export default ProUserPage;
